<template>
  <span class="zk-breadcrumb__item">
    <span class="zk-breadcrumb__item__inner" ref="link"><slot></slot></span><span class="zk-breadcrumb__separator">{{separator}}</span>
  </span>
</template>
<script>
  export default {
    name: 'ZkBreadcrumbItem',
    props: {
      to: {},
      replace: Boolean
    },
    data() {
      return {
        separator: ''
      };
    },
    mounted() {
      this.separator = this.$parent.separator;
      var self = this;
      if (this.to) {
        let link = this.$refs.link;
        link.addEventListener('click', _ => {
          let to = this.to;
          self.replace ? self.$router.replace(to)
                       : self.$router.push(to);
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// breadcrumb-item.vue?30c7ac4a